import React from 'react';
import '../../pages/landing.css';

const LandingFooter: React.FC = () => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-bottom">
                    <p>&copy; 2026 Asknow. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default LandingFooter;
